import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_BOLD } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.BOLD,
    value: false,
    tipMsg: i18n.t('加粗'),
    icon: TOOLBAR_BOLD,
    shortcut: {
        win: 'Ctrl+B',
        mac: '⌘+B',
    },
    twdConfig: {
        action: TDWActionType.TEXT_BOLD,
        notReportVer5: true,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        shortcut: config.shortcut,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: i18n.t<string>('粗体'),
    },
];
